import { Directive, inject, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[ffaOpenDialogContent]',
})
export class OpenDialogContentDirective {
    public viewContainerRef = inject(ViewContainerRef);
}
